import { buildPrivateApiUrl } from '../config/api'

export const useOrders = () => {
  const apiUrl = buildPrivateApiUrl('orders')

  const withAuth = () => {
    const token = localStorage.getItem('token')
    if (!token) {
      throw new Error('Unauthorized')
    }
    return {
      Authorization: `${token}`,
      'Content-Type': 'application/json'
    }
  }

  const fetchOrders = async (filters = {}) => {
    const query = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, value)
      }
    })
    const response = await fetch(`${apiUrl}${query.toString() ? `?${query.toString()}` : ''}`, {
      headers: withAuth()
    })
    if (!response.ok) {
      throw new Error(`Failed to fetch orders (${response.status})`)
    }
    return response.json()
  }

  const getOrder = async (orderId) => {
    const response = await fetch(`${apiUrl}/${orderId}`, {
      headers: withAuth()
    })
    if (!response.ok) {
      throw new Error(`Failed to fetch order (${response.status})`)
    }
    return response.json()
  }

  const updateOrder = async (orderId, payload) => {
    const response = await fetch(`${apiUrl}/${orderId}`, {
      method: 'PUT',
      headers: withAuth(),
      body: JSON.stringify(payload)
    })
    if (!response.ok) {
      throw new Error(`Failed to update order (${response.status})`)
    }
    return response.json()
  }

  const resendConfirmation = async (orderId) => {
    const response = await fetch(`${apiUrl}/${orderId}/resend-confirmation`, {
      method: 'POST',
      headers: withAuth()
    })
    if (!response.ok) {
      throw new Error(`Failed to resend confirmation (${response.status})`)
    }
    return response.json()
  }

  const uploadFinalInvoice = async (orderId, file) => {
    const authHeaders = withAuth()
    const prepareResponse = await fetch(`${apiUrl}/${orderId}/final-invoice`, {
      method: 'POST',
      headers: authHeaders,
      body: JSON.stringify({
        file_name: file.name,
        content_type: file.type,
        size: file.size
      })
    })
    const preparePayload = await prepareResponse.json()
    if (!prepareResponse.ok) {
      throw new Error(preparePayload.message || `Failed to prepare invoice upload (${prepareResponse.status})`)
    }

    const uploadResponse = await fetch(preparePayload.upload_url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type
      },
      body: file
    })
    if (!uploadResponse.ok) {
      throw new Error(`Failed to upload invoice (${uploadResponse.status})`)
    }

    const completeResponse = await fetch(`${apiUrl}/${orderId}/final-invoice`, {
      method: 'POST',
      headers: authHeaders,
      body: JSON.stringify({
        storage_key: preparePayload.storage_key,
        original_filename: file.name,
        content_type: file.type,
        size: file.size
      })
    })
    const completePayload = await completeResponse.json()
    if (!completeResponse.ok) {
      throw new Error(completePayload.message || `Failed to publish invoice (${completeResponse.status})`)
    }
    return completePayload
  }

  return { fetchOrders, getOrder, updateOrder, resendConfirmation, uploadFinalInvoice }
}
